import api from "@/api/axios/axios.js";

// Base del recurso de Consumo de Datos por unidad en custion de tokens y de costos.
// .
const BASE = "/calculateApi/usage/";

// Consumo agregado por entidad. Filtros opcionales:
//   { anio }        -> todo el año (agregado)
//   { anio, mes }   -> solo ese mes del año
export async function getUsageForEntity(params = {}) {
  const resp = await api.get(`${BASE}por-entidad/`, { params });
  return resp.data;
}
